import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReferralNotesRoutingModule } from './referral-notes-routing.module';
import { ReferralNotesComponent } from './referral-notes.component';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { MaskedTextBoxModule, NumericTextBoxAllModule, NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { NgSelectModule } from '@ng-select/ng-select';
import { MyDatePickerModule } from 'mydatepicker';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { ClientNotesService } from './referral-notes.service';
import { ClientNotesDateService } from './referral-nottes-service';

@NgModule({
  declarations: [ReferralNotesComponent],
  imports: [
    CommonModule,
    FormsModule,
    GridModule,
    ReactiveFormsModule,
    MultiselectDropdownModule,
    NumericTextBoxModule,
    NumericTextBoxAllModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    NgSelectModule,
    ReferralNotesRoutingModule,
    MyDatePickerModule,
    PDFExportModule
  ],
  exports:[ReferralNotesComponent],
  
  providers:[ClientNotesService,ClientNotesDateService ]
})
export class ReferralNotesModule { }
